import { createContext, useContext, type PropsWithChildren } from "react";

export type ScoutProUpsellStatus = "dismissed";

export type ScoutProUpsellContextValue = {
  dismissedUpsells: Record<string, ScoutProUpsellStatus>;
  onDismiss: (input: { upsellId: string }) => Promise<void>;
};

const ScoutProUpsellContext = createContext<ScoutProUpsellContextValue | undefined>(undefined);

export function ScoutProUpsellProvider({
  value,
  children,
}: PropsWithChildren<{ value: ScoutProUpsellContextValue }>) {
  return <ScoutProUpsellContext.Provider value={value}>{children}</ScoutProUpsellContext.Provider>;
}

export function useScoutProUpsellContext(): ScoutProUpsellContextValue | undefined {
  return useContext(ScoutProUpsellContext);
}
